export default __webpack_public_path__ + "static/media/logo2.64d3c31b.png";